<div class="bmc-ldap-basic">
    <div class="bmc-ldap-basic__title">
        <label class="bmc-ldap-basic__title__text">{{'LDAP.TITLE' | translate}}</label>
    </div>
    <form #ldapBasicConfigurationForm="ngForm">
        <div class="bmc-ldap-basic__content">
            <div class="bmc-ldap-basic__content__left" *ngIf="metadata">
                <div *ngFor="let property of metadata.properties | keyvalue">
                    <bzg-input class="bmc-ldap-basic__content__left__input" name="{{property.key}}text" type='text' *ngIf="property.value.type === 'text'" [required]="property.value.required"
                                [maxlength]="property.value.max === -1 ? undefined : property.value.max"
                                [(ngModel)]="ldapConfiguration[property.key]"
                                placeholder="{{'LDAP.TYPE_'+ (property.key | uppercase) | translate}}">
                                {{'LDAP.' + (property.key | uppercase) | translate}}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                    </bzg-input>
                    <bzg-input class="bmc-ldap-basic__content__left__input" name="{{property.key}}password" type="password" *ngIf="property.value.type === 'password'" [required]="property.value.required"
                                [(ngModel)]="ldapConfiguration[property.key]"
                                (blur)="encryptBasicSecurityPassword()"
                                placeholder="{{'LDAP.TYPE_'+ (property.key | uppercase) | translate}}">
                                {{'LDAP.' + (property.key | uppercase) | translate}}
                    </bzg-input>
                    <bzg-input  class="bmc-ldap-basic__content__left__input" name="{{property.key}}number" *ngIf="property.value.type === 'number'"
                                [type]="'number'" [min]="property.value.min" [max]="property.value.max"
                                [required]="property.value.required" (keypress)="utilsService.onlyNumbers($event)"
                                [(ngModel)]="ldapConfiguration[property.key]"
                                placeholder="{{'LDAP.TYPE_'+ (property.key | uppercase) | translate}}">
                                {{'LDAP.' + (property.key | uppercase) | translate}}
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                                <bzg-max-error>{{'GLOBAL.INVALID_MAX_VALUE' | translate}} {{property.value.max}}</bzg-max-error>
                                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{property.value.min}}</bzg-min-error>
                    </bzg-input>
                </div>
            </div>
            <div class="bmc-ldap-basic__content__right">
                <label class="bmc-ldap-basic__content__right__text">{{ 'GLOBAL.ENABLED' | translate }}</label>
                <bzg-checkbox name="enable-config" class="bmc-ldap-basic__content__right__checkbox" [checked]="ldapConfiguration.enabled" [ngModel]="ldapConfiguration.enabled" (ngModelChange)="changeCheck()"></bzg-checkbox>
            </div>
        </div>
    </form>
</div>
